// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3ROXD","content":"RecentSearches_content__JDPxr"};